import axios from 'axios'

import type { UserApplication } from 'libs/types/src/user-application'

import env from '../environments'

export async function deleteUserApplication(userApplicationId: string) {
	await axios.delete(`${env.apiUrl}/users-applications/${userApplicationId}`)
}

export async function createUserApplication(userId: string, applicationId: string, readOnly: boolean) {
	const response = await axios.post(`${env.apiUrl}/users-applications`, {
		userId,
		applicationId,
		readOnly
	})

	return response.data as UserApplication
}

export async function updateUserApplication(userApplicationId: string, readOnly: boolean) {
	await axios.put(`${env.apiUrl}/users-applications/${userApplicationId}`, {
		readOnly
	})
}
